import { Check } from 'lucide-react'
import {
	Button,
	Icon,
	Popover,
	PopoverContent,
	PopoverTrigger,
	Command,
	CommandEmpty,
	CommandGroup,
	CommandInput,
	CommandItem,
	CommandList,
} from '#app/ui/components'

export type Genre = {
	id: string
	name: string
}

type GenreFilterProps = {
	genres: Genre[]
	selectedGenres: string[]
	onSelect: (genres: string[]) => void
	open: boolean
	onOpenChange: (open: boolean) => void
	searchValue: string
	onSearchChange: (value: string) => void
}

export function GenreFilter({
	genres,
	selectedGenres,
	onSelect,
	open,
	onOpenChange,
	searchValue,
	onSearchChange,
}: GenreFilterProps) {
	return (
		<Popover open={open} onOpenChange={onOpenChange}>
			<PopoverTrigger asChild>
				<Button
					variant="outline"
					role="combobox"
					aria-expanded={open}
					className="flex-1"
				>
					<span className="truncate">
						{selectedGenres.length > 0
							? selectedGenres.length <= 3
								? selectedGenres.join(`, `)
								: `${selectedGenres.slice(0, 3).join(`, `)} +${selectedGenres.length - 3}`
							: `All Genres`}
					</span>
					{selectedGenres.length > 0 ? (
						<Icon
							name="cross-2"
							className="ml-2 h-4 w-4 shrink-0 cursor-pointer"
							onClick={(e) => {
								e.stopPropagation()
								onSelect([])
							}}
						/>
					) : (
						<Icon name="chevron-down" className="ml-2 h-4 w-4 shrink-0" />
					)}
				</Button>
			</PopoverTrigger>
			<PopoverContent side="bottom" align="start">
				<Command shouldFilter={true}>
					<CommandInput
						placeholder="Search genres..."
						value={searchValue}
						onValueChange={onSearchChange}
						autoFocus
					/>
					<CommandList>
						<CommandEmpty>No genre found.</CommandEmpty>
						<CommandGroup>
							<CommandItem
								value="all-genres"
								onSelect={() => {
									onSelect([])
									onOpenChange(false)
									onSearchChange(``)
								}}
							>
								<Check
									className={`mr-2 h-4 w-4 ${
										selectedGenres.length === 0 ? `opacity-100` : `opacity-0`
									}`}
								/>
								All Genres
							</CommandItem>
							{genres.map((genre) => (
								<CommandItem
									key={genre.id}
									value={genre.name}
									onSelect={(genreName) => {
										const newGenres = selectedGenres.includes(genreName)
											? selectedGenres.filter((g) => g !== genreName)
											: [...selectedGenres, genreName]
										onSelect(newGenres)
										// Clear the search for quick multi-selection
										onSearchChange(``)
									}}
								>
									<Check
										className={`mr-2 h-4 w-4 ${
											selectedGenres.includes(genre.name)
												? `opacity-100`
												: `opacity-0`
										}`}
									/>
									{genre.name}
								</CommandItem>
							))}
						</CommandGroup>
					</CommandList>
				</Command>
			</PopoverContent>
		</Popover>
	)
}
